import React from "react";
import { useAdminData } from "../../AdminContext";

function Dashboard() {
  const { adminName } = useAdminData();
  return (
    <div>
      <h1>Assessworth Admin</h1>
      <p>Welcome to the home page, {adminName ?? "Admin"}!</p>
    </div>
  );
}

export default Dashboard;
